import { Form } from "@unform/web";
import { useEffect } from "react";

import NexLogo from "Assets/Admin/NexDigital.png";

import PrimaryButton from "Components/Admin/Buttons/Variants/Primary";
import Input from "Components/Admin/Form/Input";
import CaptchaWidget from "Components/Common/CaptchaWidget";
import Checkbox from "Components/Global/Form/Checkbox";
import TypographyHead from "Components/Global/Typography/Head";

import * as S from "../styles";
import * as SP from "./styles";

import { useTheme } from "styled-components";

const StepPassword = ({
  setReCaptchaToken,
  turnstileRef,
  loading,
  switchStep,
  submitData,
}) => {
  const theme = useTheme();

  useEffect(() => {
    const passwordInput = document.querySelector("input[type=password]");

    if (passwordInput) passwordInput.focus();
  }, []);

  return (
    <S.Wrapper>
      <S.Row>
        <img src={NexLogo} alt="Nex Logo" />
        <TypographyHead
          dark
          title="Bem vindo de volta"
          description="Digite a senha para acessar sua conta."
        />
      </S.Row>
      <Form onSubmit={submitData}>
        <S.Row>
          <Input
            type="password"
            required
            name="password"
            label="Senha"
            placeholder="********"
          />
          <S.Selector>
            <Checkbox label="Lembrar-me" name="remember" />
            {/* <S.ForgotPassword onClick={() => setLoginStep("forgotPassword")}>
              Esqueceu a senha?
            </S.ForgotPassword> */}
          </S.Selector>

          <SP.RecaptchaWrapper>
            <CaptchaWidget ref={turnstileRef} onSuccess={setReCaptchaToken} />
          </SP.RecaptchaWrapper>
          <PrimaryButton text="Continuar" type="submit" disabled={loading} />
          <PrimaryButton
            outline
            icon={{
              name: "ChevronLeft",
              position: "left",
              color: theme.colors.primary.vividCerulean,
            }}
            text="Voltar"
            type="button"
            disabled={loading}
            onClick={switchStep}
          />
        </S.Row>
      </Form>
    </S.Wrapper>
  );
};

export default StepPassword;
